import { Component, Input, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { InstagramService } from "src/app/services/social/instagram.service";

@Component({
  selector: "app-instagram-item",
  templateUrl: "./instagram-item.component.html",
  styleUrls: ["./instagram-item.component.css"],
})
export class InstagramItemComponent implements OnInit {

  @Input() media: any = {};
  @Input() itemType: any = {};
  showFullCaption = false;
  activeSlide = 0;
  instagramName = '';
  constructor(
    private instagramService: InstagramService,
    private toaster: ToastrService
  ) {

      instagramService.instagramDetails().subscribe(response => {
        this.instagramName = response.data.payload.username;
    });
  }

  ngOnInit() {

  }
  nextSlide() {
    const max = this.media.children.data.length;
    if (this.activeSlide < max) { this.activeSlide++; }
  }

  prevSlide() {
    if (this.activeSlide > 0) { this.activeSlide--; }
  }
  getPostDetails(payload) {
          this.openPostModal(payload);
  }

  getPostComments(mediaId: string)  {
    this.instagramService.fetchComments(mediaId);
  }
  openPostModal(post: object) {
    this.instagramService.postToView.next(post);
  }

}
